import { GenericLoadingElement } from "../../components/GenericLoadingElement"

export interface props {
    className?: string
}

export const ContractsLoading = (props: props) => {

    return (
        <div className={`jbp-site-details-loading ${props.className}`}>
            <h1 className={`mt-7 text-xl mb-8`}>Contract ID:</h1>
            <GenericLoadingElement height="h-4" count={1}></GenericLoadingElement>
        </div>
    )
}
